import { bigNumberFormat, normalizeFloat } from '@/helpers/mathHelper';

export const filters = {
  install(Vue: any) {
    Vue.filter('bigNumberFormatter', bigNumberFormat);
    Vue.filter('normalizeFloat', normalizeFloat);
  }
};
